import HttpClient from "../../clients/HttpClient";
import TagModel from "../../models/TagModel";

export default class TagService {
  static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

  public static async list(params = {}): Promise<Array<TagModel>> {
    return this.httpClient.get("/tags/index").then((res) => {
      return res.data.map((row) => new TagModel(row));
    });
  }
}

